import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=22ac6d70&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=22ac6d70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports